import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class JobTitleHistoryModel extends Model implements IModel<JobTitleHistoryModel> {
  employeeId: string = '';
  movementDate: string = '';
  jobTitleChangeTypeId: string = '';
  changeType: string = '';
  isPromotion: boolean = false;
  jobTitleId?: string;
  jobTitleName: string = '';
  costCenterId?: string;
  costCenterName: string = '';
  salary: number = 0;
  variation: number | null = null;

  static create(input: any): JobTitleHistoryModel {
    return ObjectMapper.deserialize<JobTitleHistoryModel>(JobTitleHistoryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
